import { render } from "./ClViewDescription.vue?vue&type=template&id=466bbfa2&scoped=true"
import script from "./ClViewDescription.vue?vue&type=script&lang=js"
export * from "./ClViewDescription.vue?vue&type=script&lang=js"

import "./ClViewDescription.vue?vue&type=style&index=0&id=466bbfa2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466bbfa2"]])

export default __exports__